<div class="ap-margin-bottom-3">{{ 'financial-obligations.private-lease.main-applicant.amount' | apContent }}</div>
<ap-amount-input
    id="privateLeaseMainAmount"
    [helpText]="'financial-obligations.private-lease.amount.help-text' | apContent"
    [label]="'global.monthly-input.label' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
>
</ap-amount-input>

@if (store.hasCoApplicant) {
    <div class="ap-margin-bottom-3">{{ 'financial-obligations.private-lease.co-applicant.amount' | apContent }}</div>
    <ap-amount-input
        id="privateLeaseCoAmount"
        [helpText]="'financial-obligations.private-lease.amount.help-text' | apContent"
        [label]="'global.monthly-input.label' | apContent"
        [showSymbol]="true"
        [numberOfDecimals]="0"
        [formControl]="coApplicantControl"
    ></ap-amount-input>
}

<additional-info
    [key]="questionKey"
    titleKey="financial-obligations.private-lease.amount.additional-info.title"
    contentKey="financial-obligations.private-lease.amount.additional-info.content"
    modalUrlKey="financial-obligations.private-lease.amount.additional-info.title"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
